import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import { dayjs } from '@isyc-react/core/dayjs';
import clsx from 'clsx';
import { nsnewo } from "../../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardCourseModalComponent } from "./card-course-modal.component";
export const CardCourseBodyComponent = props => {
  const {
    children,
    data,
    onClick
  } = props;
  const {
    name,
    startingDate,
    endingDate
  } = data;
  const {
    t
  } = useTranslation(nsnewo.common);
  const [showModal, setShowModal] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "card-title font-size-20 mb-auto cursor text-center"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "card-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center text-center font-size-14 fw-500 mb-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 mb-2 text-primary"
  }, dayjs(startingDate).format('DD/MM/YYYY'), " - ", dayjs(endingDate).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
    className: clsx('col-12 mt-2', {
      'opacity-20': !data.objective && !data.description,
      'cursor-pointer': data.objective || data.description
    })
  }, /*#__PURE__*/React.createElement("u", {
    className: "text-primary",
    onClick: data.objective || data.description ? () => setShowModal(true) : undefined
  }, t('newo.cardCourse.moreInformation')))), children), /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-outline-primary btn-pill border-2 fw-600 text-center col-12 py-2",
    onClick: () => onClick && onClick(data)
  }, t('newo.cardCourse.access'))), /*#__PURE__*/React.createElement(CardCourseModalComponent, {
    data: data,
    show: showModal,
    onClose: () => setShowModal(false)
  }));
};